import { menuGetters } from './menu'
import { colorGetters } from './color'

/**
 * This is where we fetch the state
 * This is only needed if you need post process ur state like filters etc
 */
export const getters = Object.assign({}, menuGetters, colorGetters)
